import Hit from './Hit';

export default Hit;
